import moment from "moment";
import React from "react";
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers";

const MasterInvoice = (props) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(amount);
  };
  return (
    <>
      <div className="card" ref={props?.componentRef}>
        <div className="card-body py-20">
          <div className="mw-lg-950px mx-auto w-100">
            <div className="d-flex justify-content-between flex-column flex-sm-row mb-19">
              <div>
                <h1 className="pb-7">
                  INVOICE{" "}
                  {props?.invoices?.masterInvoiceNumber &&
                    "#" + props?.invoices?.masterInvoiceNumber}
                </h1>
                   {props?.startDate && props?.endDate && (
                      <div className="d-flex flex-stack mb-3">
                          <h5 className="fw-semibold pr-2">Pay Period :</h5>
                          <p className="text-end font-size-lg font-weight-semibold mx-3">
                            {moment(props?.startDate).format("MMMM DD, YYYY")}
                                      {" - "}
                            {moment(props?.endDate).format("MMMM DD, YYYY")}
                        </p>
                    </div>
                 )}
                {props?.invoices?.startDate && props?.invoices?.endDate && (
                  <div className="d-flex flex-stack mb-3">
                    <h5 className="fw-semibold pr-2">Pay Period :</h5>
                    <p className="text-end font-size-lg font-weight-semibold mx-3">
                      {moment(props?.invoices?.startDate).format(
                        "MMMM DD, YYYY"
                      )}
                      {" - "}
                      {moment(props?.invoices?.endDate).format("MMMM DD, YYYY")}
                    </p>
                  </div>
                )}
                <div className="d-flex flex-stack mb-3">
                  <h5 className="fw-semibold pr-2">Date of issue</h5>
                  <p className="text-end font-size-lg font-weight-semibold">
                    {props?.invoices?.created
                      ? moment(props?.invoices?.created).format("MMMM DD, YYYY")
                      : moment().format("MMMM DD, YYYY")}
                  </p>
                </div>
                <div className="d-flex flex-stack mb-3">
                  <h4 className="fw-semibold pr-2">Date due </h4>
                  <p className="text-end font-size-lg font-weight-semibold">
                    {props?.invoices?.created
                      ? moment(props?.invoices?.created).add('days', props?.invoices?.invoiceDueDateDays || 0).format("MMMM DD, YYYY")
                      : moment().add('days', props?.invoices?.invoiceDueDateDays || 0).format("MMMM DD, YYYY")}
                  </p>
                </div>
              </div>

              <div className="text-sm-end">
                <a href="#">
                  <img
                    alt="Logo"
                    src={toAbsoluteUrl("/media/logos/logo-letter-2.svg")}
                  />
                </a>
              </div>
            </div>
            <div className="d-flex justify-content-between flex-column flex-sm-row mb-19">
              <div>
                <h5 className="font-weight-bold pe-5 pb-2">
                  {props?.invoices?.businessName || "DeliveryEase Inc."}
                </h5>
                {!props?.invoices?.address && (
                  <>
                    <div className="text-end font-size-md font-weight-bolder">
                      2100 Bloor Street West
                    </div>
                    <div className="text-end font-size-md font-weight-bolder">
                      Suite 6164
                    </div>
                    <div className="text-end font-size-md font-weight-bolder">
                      Toronto, ON, M6S 5A5
                    </div>
                  </>
                )}
                {props?.invoices?.address && (
                  <>
                    <div className="text-end font-size-md font-weight-bolder">
                      {props?.invoices?.address?.line1}
                    </div>
                    {props?.invoices?.address?.line2 && (
                      <div className="text-end font-size-md font-weight-bolder">
                        {props?.invoices?.address?.line2}
                      </div>
                    )}
                    <div className="text-end font-size-md font-weight-bolder">
                      {props?.invoices?.address?.city}
                      {", "}
                      {props?.invoices?.address?.state}
                      {", "}
                      {props?.invoices?.address?.postalCode}
                    </div>
                    <div className="text-end font-size-md font-weight-bolder">
                      {props?.invoices?.address?.country === "CA"
                        ? "Canada"
                        : props?.invoices?.address?.country}
                    </div>
                  </>
                )}
                <div className="text-end font-size-md font-weight-bolder">
                  accounting@deliveryease.co
                </div>
                <div className="text-end font-size-md font-weight-bolder">
                  +1 (855) 272-7625
                </div>
                <div className="text-end font-size-md font-weight-bolder">
                  GST/HST Registration No: {props?.invoices?.hstNumber}
                </div>
              </div>
              {
                <div className="">
                  <div className="d-flex flex-column">
                    <h5 className="font-weight-bold mb-3">Bill To</h5>
                    <div className="text-end font-size-md font-weight-bolder">
                      {props?.invoices?.invoiceCompanyName}
                    </div>
                    <div className="text-end font-size-md font-weight-bolder">
                      {props?.invoices?.addressBillTo?.name}
                    </div>
                    <div className="text-end font-size-md font-weight-bolder">
                      {props?.invoices?.addressBillTo?.address1}
                    </div>
                    {props?.invoices?.addressBillTo?.address2 && (
                      <div className="text-end font-size-md font-weight-bolder">
                        {props?.invoices?.addressBillTo?.address2}
                      </div>
                    )}
                    <div className="text-end font-size-md font-weight-bolder">
                      {props?.invoices?.addressBillTo?.city}
                      {", "}
                      {props?.invoices?.addressBillTo?.state}
                      {", "}
                      {props?.invoices?.addressBillTo?.zipCode}
                    </div>
                    <div className="text-end font-size-md font-weight-bolder">
                      {props?.invoices?.addressBillTo?.country}
                    </div>
                    <div className="text-end font-size-md font-weight-bolder">
                      {props?.invoices?.addressBillTo?.phoneNumber}
                    </div>
                    <div className="text-end font-size-md font-weight-bolder">
                      {props?.invoices?.addressBillTo?.email}
                    </div>
                  </div>
                </div>
              }
            </div>
            <div className="">
              <div className="d-flex flex-columnw-100">
                <h1 className="font-weight-bold mb-3">
                  {formatCurrency(props?.invoices?.totalAmount)} due{" "}
                  {props?.invoices?.created
                    ? moment(props?.invoices?.created).add('days', props?.invoices?.invoiceDueDateDays || 0).format("MMMM DD, YYYY")
                    : moment().add('days', props?.invoices?.invoiceDueDateDays || 0).format("MMMM DD, YYYY")}
                </h1>
              </div>
              <div className="">
                <div className="flex-grow-1 pt-8 mb-13">
                  <div className="table-responsive mb-14">
                    <table className="table align-middle table-nowrap table-centered mb-0">
                      <thead>
                        <tr>
                          <th style={{ width: 400 }}>Description</th>
                          <th></th>
                          <th></th>
                          <th>Quantity</th>
                          <th>Unit Price</th>
                          <th className="text-end">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {props?.invoices?.invoiceDetails?.map((item, index) => (
                          <tr key={index}>
                            <td>
                              <div>
                                {props?.invoices?.showInvoiceNumber !== true ? 
                                <h5 className="text-truncate font-size-14 mb-1">
                                  {item?.address1}{" "}
                                  {item?.address2 + item?.address2 ? ", " : ""}{" "}
                                  {item?.city + ", "}
                                  {item?.state + ", "} {item?.zipCode + ", "}{" "}
                                  {item?.country}
                                </h5>: 
                                <h5 className="text-truncate font-size-14 mb-1">
                                  {"#"+item?.invoiceNumber}
                                </h5>}
                              </div>
                            </td>
                            <td></td>
                            <td></td>
                            <td>1</td>
                            <td>{formatCurrency(item?.total)}</td>
                            <td className="text-end">
                              {formatCurrency(item?.total)}
                            </td>
                          </tr>
                        ))}

                        <tr>
                          <td className="border-0"></td>
                          <td className="border-0"></td>
                          <td className="border-0"></td>
                          <th
                            scope="row"
                            colSpan={2}
                            className="border-0 text-end"
                          >
                            Subtotal
                          </th>
                          <td className="border-0 text-end font-size-md font-weight-bolder">
                            {formatCurrency(props?.invoices?.subTotal)}
                          </td>
                        </tr>

                        <tr>
                          <td className="border-0"></td>
                          <td className="border-0"> </td>
                          <td className="border-0"></td>
                          <th
                            scope="row"
                            colSpan={2}
                            className="border-0 text-end"
                          >
                            HST - Canada
                          </th>
                          <td className="border-0 text-end font-size-md font-weight-bolder">
                            {formatCurrency(props?.invoices?.totalTax)}
                          </td>
                        </tr>

                        {props?.invoices?.totalCod > 0  &&<tr>
                          <td className="border-0"></td>
                          <td className="border-0"> </td>
                          <td className="border-0"></td>
                          <th
                            scope="row"
                            colSpan={2}
                            className="border-0 text-end"
                          >
                            Total COD
                          </th>
                          <td className="border-0 text-end font-size-md font-weight-bolder">
                            {formatCurrency(props?.invoices?.totalCod)}
                          </td>
                        </tr>}

                        <tr>
                          <td className="border-0"></td>
                          <td className="border-0"></td>
                          <td className="border-0"></td>
                          <th
                            scope="row"
                            colSpan={2}
                            className="border-0 text-end"
                          >
                            Amount due
                          </th>
                          <td className="border-0 text-end">
                            <h4 className="m-0 font-size-md font-weight-bolder">
                              {formatCurrency(props?.invoices?.totalAmount)}
                            </h4>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
         <div className="d-flex justify-content-between flex-column flex-sm-row mb-10">
              <div className="mb-10">
                <h5 className="font-weight-bold pe-5 pb-2">
                  DeliveryEase Inc.
                </h5>
                <p className="text-end font-size-md font-weight-bolder mb-10">
                  Humbled to be your pharmacy delivery partner 🙂
                </p>
              </div>
              <div>
              <h5 className="font-weight-bold mb-5">
                DeliveryEase Banking Information:
              </h5>
              <div className="d-flex align-items-center">
                <p className="font-weight-bolder p-0 mr-2">
                  Beneficiary Name:
                </p>
                <p className="font-size-md font-weight-bold p-0">
                  {props?.invoices?.businessName || "DeliveryEase Inc."}
                </p>
              </div>
              <div className="d-flex flex-column">
                <p className="font-weight-bolder p-0 mr-2">
                  Corporate Address:
                </p>
                {!props?.invoices?.address && (
                  <>
                    <p className="font-size-md font-weight-bold p-0 mb-0">
                      2100 Bloor Street West
                    </p>
                    <p className="font-size-md font-weight-bold p-0 mb-0">
                      Suite 6164
                    </p>
                    <p className="font-size-md font-weight-bold p-0">
                      Toronto, ON, M6S 5A5
                    </p>
                  </>
                )}
                {props?.invoices?.address && (
                  <>
                    <p className="font-size-md font-weight-bold p-0 mb-0">
                      {props?.invoices?.address?.line1}
                    </p>
                    {props?.invoices?.address?.line2 && (
                      <p className="font-size-md font-weight-bold p-0 mb-0">
                        {props?.invoices?.address?.line2}
                      </p>
                    )}
                    <p className="font-size-md font-weight-bold p-0 mb-0">
                      {props?.invoices?.address?.city}
                      {", "}
                      {props?.invoices?.address?.state}
                      {", "}
                      {props?.invoices?.address?.postalCode}
                    </p>
                    <p className="font-size-md font-weight-bold p-0">
                        {props?.invoices?.address?.country === "CA" ? "Canada" : props?.invoices?.address?.country}
                    </p>
                  </>
                )}
              </div>
              <div className="d-flex align-items-center">
                <p className="font-weight-bolder p-0 mr-2">
                  Beneficiary Bank:
                </p>
                <p className="font-size-md font-weight-bold p-0">
                  {props?.invoices?.beneficiaryBank}
                </p>
              </div>
              <div className="d-flex align-items-center">
                <p className="font-weight-bolder p-0 mr-2">
                  Beneficiary Account Number:
                </p>
                <p className="font-size-md font-weight-bold p-0">
                  {props?.invoices?.beneficiaryAccountNumber}
                </p>
              </div>
              <div className="d-flex align-items-center">
                <p className="font-weight-bolder p-0 mr-2">
                  Transit Number:
                </p>
                <p className="font-size-md font-weight-bold p-0">
                  {props?.invoices?.transitNumber}
                </p>
              </div>
              <div className="d-flex align-items-center">
                <p className="font-weight-bolder p-0 mr-2">
                 Transit Code: 
                </p>
                <p className="font-size-md font-weight-bold p-0">
                  {props?.invoices?.transitCode}
                </p>
              </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MasterInvoice;
